import { useEffect, useRef, useState } from "react";
import { motion, useInView, animate } from "framer-motion";

const STATS = [
  { value: 500, suffix: "+", label: "Eladott autó" },
  { value: 98, suffix: "%", label: "Elégedett ügyfél" },
  { value: 100, suffix: "%", label: "Átlátható folyamat" },
];

const Counter = ({ value, suffix, label, index }) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-80px" });
  const [display, setDisplay] = useState(0);

  useEffect(() => {
    if (!inView) return;
    const controls = animate(0, value, {
      duration: 2.2,
      ease: [0.16, 1, 0.3, 1],
      onUpdate: (v) => setDisplay(Math.round(v)),
    });
    return () => controls.stop();
  }, [inView, value]);

  return (
    <motion.div
      ref={ref}
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.7, delay: index * 0.15 }}
      className="text-center px-6"
      data-testid={`trust-counter-${index}`}
    >
      <div className="font-display text-5xl sm:text-7xl font-extrabold text-transparent bg-clip-text bg-gradient-to-b from-[#F0D77B] to-[#B8860B]">
        {display}{suffix}
      </div>
      <div className="mt-3 text-xs sm:text-sm tracking-[0.25em] uppercase text-white/45 font-semibold">{label}</div>
    </motion.div>
  );
};

export const TrustCounters = () => (
  <section id="trust" className="relative py-20 sm:py-32 bg-[#050505] overflow-hidden" data-testid="trust-section">
    <div className="absolute inset-0 pointer-events-none" style={{ background: "radial-gradient(ellipse at 50% 0%, rgba(212,175,55,0.05), transparent 55%)" }} />
    <div className="max-w-6xl mx-auto px-4 sm:px-6">
      <div className="gold-divider mb-16 sm:mb-24" />
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-12 sm:gap-6">
        {STATS.map((s, i) => <Counter key={s.label} {...s} index={i} />)}
      </div>
      <div className="gold-divider mt-16 sm:mt-24" />
    </div>
  </section>
);
